module.exports = __webpack_public_path__ + "static/media/logo.434b94ae.svg";